import EnterOtpStep from './EnterOtpStep';
import EnterSms2faStep from './EnterSms2faStep';
import useEnterSms2faStep from './useEnterSms2faStep';

type Props = {
  isPopover?: boolean;
  onSuccess?: () => void;
};
const Uses2FAStep: FC<Props> = ({ isPopover, onSuccess }) => {
  const { phoneHint, handleCodeSubmit, authCodeErrorMessage, uses2FA } =
    useEnterSms2faStep({ isPopover, onSuccess });

  if (uses2FA) {
    return (
      <EnterOtpStep
        authCodeErrorMessage={authCodeErrorMessage}
        handleCodeSubmit={handleCodeSubmit}
      />
    );
  }

  return (
    <EnterSms2faStep
      authCodeErrorMessage={authCodeErrorMessage}
      phoneHint={phoneHint}
      handleCodeSubmit={handleCodeSubmit}
    />
  );
};

export default Uses2FAStep;
